module.exports = __webpack_public_path__ + "img/option2.c1e3ba51.png";